import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { VERSION_FIELD_DESCRIPTOR } from './_versionField.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_OVERRIDE } from '../types/technical-sheet-override.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for TechnicalSheetOverride.
 * Stored in 'org/{orgId}/technical-sheet-override'.
 */
export const technicalSheetOverrideDescriptor = {
    name: TECHNICAL_SHEET_OVERRIDE,
    label: 'Override de Ficha Técnica',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet-override',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Override de processos e insumos aplicado sobre fichas técnicas base',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: entidade versionada (spec 0045) — getById em cache devolve versão velha e anula a detecção de conflito.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        { name: 'overrideStage', label: 'Estágio', type: 'string', required: true },
        { name: 'scopeType', label: 'Tipo de escopo', type: 'string', required: true },
        { name: 'colorId', label: 'Cor', type: 'string', required: false },
        { name: 'variationOptionId', label: 'Opção de variação', type: 'string', required: false },
        { name: 'machineId', label: 'Máquina', type: 'string', required: false },
        { name: 'machineGroupId', label: 'Grupo de máquinas', type: 'string', required: false },
        { name: 'productId', label: 'Produto (escopo)', type: 'string', required: false },
        { name: 'technicalSheetId', label: 'Ficha técnica (escopo)', type: 'string', required: false },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
        VERSION_FIELD_DESCRIPTOR,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'colorId',
            targetEntity: 'Color',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Cor do eixo de escopo COLOR',
        },
        {
            fieldName: 'variationOptionId',
            targetEntity: 'VariationOption',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Opção de variação do eixo de escopo OPTION',
        },
        {
            fieldName: 'machineId',
            targetEntity: 'Machine',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Máquina do eixo de escopo MACHINE',
        },
        {
            fieldName: 'machineGroupId',
            targetEntity: 'MachineGroup',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Grupo de máquinas do eixo de escopo MACHINE',
        },
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Narrowing: restringe o override a um produto',
        },
        {
            fieldName: 'technicalSheetId',
            targetEntity: 'TechnicalSheet',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Narrowing: restringe o override a uma ficha técnica',
        },
        {
            fieldName: 'id',
            targetEntity: 'TechnicalSheetOverrideProcess',
            relationship: 'one-to-many',
            description: 'Processos deste override',
        },
        {
            fieldName: 'id',
            targetEntity: 'TechnicalSheetOverrideInput',
            relationship: 'one-to-many',
            description: 'Insumos deste override',
        },
    ],
};
//# sourceMappingURL=technical-sheet-override.descriptor.js.map